import lookup from 'country-code-lookup'
import countries from '../../consts/countries.mjs'
import env from '../env'

const availableCountries = Object.values(countries)

export const getCountryConfigs = () => {
  const countryString = env('REACT_APP_COUNTRY')?.toLowerCase()
  if (!countryString || !availableCountries.includes(countryString)) return {}

  const countryCode = countryString?.replace(/.*_/g, '')
  const country = lookup.byIso(countryCode)
  /**
  * @const {
  *  language: string,
  *  continent: string,
  *  region: string,
  *  country: string,
  *  capital: string,
  *  fips: string,
  *  iso2: string,
  *  iso3: string,
  *  isoNo: string,
  *  internet: string,
  * }
  */
  const language = env('REACT_APP_LANG')
  return { ...country, countryString, language }
}

export const getISO3166Code = () => {
  const country = getCountryConfigs()
  return country.iso2
}
